/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('MitarbeiterCtrl', ['$rootScope', '$scope', '$http', 'MainService', 'IntentService', 'NetworkService', function ($rootScope, $scope, $http, MainService, IntentService, NetworkService) {

        $scope.maId = MaId;
        MainService.setEmail($scope.maId)
        $scope.editMode = false;

        NetworkService.getMitarbeiterDetails(UserId, function (data) {
            $rootScope.$emit("setNavName", data);
        })
        NetworkService.getHighestPermission(function (data) {
            $scope.highestLevel = data.level
        })

        fields = {}
        fields["command"] = "getMitarbeiterDetails"
        fields["email"] = MaId
        var req3 = {
            method: 'POST',
            url: "Api/hosiapi.php",
            data: $.param(fields),
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        }

        $scope.parseDate = function(d)
        {

            if(d != undefined)
            {
                console.log(d)
                var myDate = new mDate(d)
            return myDate.getDate();
            }
            //var myDate = new mDate(d)
            //return myDate.getDate();
        }

        $scope.deleteMe = function()
        {
          NetworkService.deleteMe($scope.mb.email, function () {

          })

        }

        $scope.openDeleteUserDialog = function()
        {
          $("#dialog_deleteUser").modal("open")
        }

        $scope.uploadImage = function()
        {
          var img = MainService.getProfilePic()
          NetworkService.uploadProfilePic(img, $scope.mb.email, function () {

          })
        }

        $scope.calcYearDiff = function(date)
        {
            var d = new Date()
            var a = new Date(date)

            var seconds = Math.round((d-a)/1000);
            var years = Math.round(seconds/60/60/24/365);
            return years;
        }
        $rootScope.$on("openEditMode", function () {
            $scope.sendPicToEditCtrl();
            $scope.editMode = true;
        })


        $scope.openUpdateEmailDialog = function()
        {
            MainService.setDialogData("dialog_updateEmailCtrl", {email: $scope.maId})

            $("#dialog_updateEmail").modal("open")()

        }
        $scope.openUpdatePasswordDialog = function()
        {

            $("#dialog_updatePassword").modal("open")()
        }
        $scope.sendPicToEditCtrl = function ()
        {
            var picIsThere = false
            try
            {
                var img = $("#profileImgFull")[0]
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                picIsThere = true
            } catch (e)
            {
                console.log(e)
            }
            if (picIsThere)
            {
                MainService.setProfilePic(dataURL);
                $rootScope.$emit("setImage");
            }
        }
        $http(req3).then(function (data) {
            $scope.mb = data.data;
            $("#profileImg").velocity({opacity:1},{})
            $scope.blocked = (data.data.gesperrt != null)

        }, "json");

        $scope.updateUser = function ()
        {
        //$scope.uploadImage()
            var img = MainService.getProfilePic()
            $scope.mb.profilePic = img;
            console.log(img)
            NetworkService.updateUser($scope.mb, function (data) {
                console.log(data)
            })
            $scope.editMode = false;
        }
        $scope.parseIntent = function (intent)
        {
            command = intent.command
            if (command != undefined)
            {
                if (command == "block")
                {

                } else if (command == "addNote")
                {
                    $("#dialog_createNote").modal("open")();
                }
            }
        }

        intent = IntentService.getIntent();
        $scope.parseIntent(intent)


    }])
